import React,{useState,useEffect} from "react";
import "./Toggle.css"
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import {X,Plus ,TicketPlus ,Settings,EggFried,Quote,Puzzle,ShoppingBasket,MessageSquareDot,AlignLeft ,AlignRight,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog} from 'lucide-react';

const SettingsToggleCard= ({animEffect,handleCourseSettings,myCardState,setMyCardState,progress,icon,title,cursorAlign,cursorTextVal,toggleState}) =>{
    
   const dispatch = useDispatch();
   const [cardState , setCardState]= useState(myCardState=='yes'?true:false)
  
 const [animate, setAnimate] = useState(false);
  useEffect(()=>{
    setCardState(myCardState=='yes'?true:false)
    const timer = setTimeout(() => {
      setAnimate(true);  
    }, animEffect);
  
     return () => clearTimeout(timer);
   },[])
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorTextDirection='left',CursorText) =>
        {
          
          dispatch({type: "CURSORTEXTDIRECTION",payload:CursorTextDirection  });
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          dispatch({type: "CURSORTEXTDIRECTION",payload:""  });
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
return(
      

<div align="left" className="itemCourseOuter" style={{marginTop:"30px",
boxShadow:`${icon==100?"0 7px 20px 0 rgba(1,1,1,0.0)":""}`,marginBottom:"20px",height:"75px" ,
    border:`${icon==100?"":cardState?
      '2px solid #444  ': '2px dashed #bbb'}`,
        transform: animate ? 'translateY(0)' : 'translateY(50px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 1s ease',
      }}> 
  
        
  <div  className={icon===100?"advSettingsItemCardInnerTwo":"advSettingsItemCardInner"} >
    {icon===100?"":
    <div style={{ background:`${cardState?
      '#f1f1f1  ': '#f1f1f1'}`,width:"50px",height:"50px",borderRadius:"50%",
        float:"left",alignContent:"center",textAlign:"center",padding:"5px", border:`${cardState?
      '2px solid #444  ': '2px dashed #ccc'}`}}>
        {cardState?
       icon===0?<AlignLeft  size={32}  className="" color="#333" />
       :icon===1?<TicketPlus  size={32}  color="#333" 
        />:icon===2?<Quote  size={32}  color="#333"  
        />:icon===3?<ShoppingBasket  size={32}  color="#333"  
        />:icon===4?<MessageSquareDot  size={32}  color="#333" 
        />:icon===5?
       <Puzzle  size={32}   color="#333" />
       :icon===6?<Settings color="#333"  size={32} />:icon===7?<AlignRight  size={32}  color="#333" />:icon===8?<EggFried  size={32}  color="#333" />:""
      :  icon===0?<AlignLeft  size={32}  className="" color="#777" />
       :icon===1?<TicketPlus  size={32}  color="#777" 
        />:icon===2?<Quote  size={32}  color="#777"  
        />:icon===3?<ShoppingBasket  size={32}  color="#777"  
        />:icon===4?<MessageSquareDot  size={32}  color="#777" 
        />:icon===5?
       <Puzzle  size={32}   color="#777" />
       :icon===6?<Settings color="#777"  size={32} />:icon===7?<AlignRight  size={32}  color="#777" />:icon===8?<EggFried  size={32}  color="#777" />:""}</div> 
        }
   <h4  onMouseEnter={
            ()=>handleMouseEnter("#fff","#333",cursorAlign,cursorTextVal)
                }
        onMouseLeave={handleMouseLeave}>{title}</h4> 
    <div
           
           className={`circlekMedium activek` }
           style={{background: `${  `conic-gradient(${cardState?
            '#777':'#ccc'} 0% ${cardState?
            100:progress}%, #ffffff 
                                              ${cardState?
            100:progress}% 100%)`
                                              }
           `,border:`${cardState?
            '0px solid #777  ': '0px solid #ccc'}`,float:"right",marginTop:"-55px"}} 
         ><div   className={`circlekMediumInn `} style={{border:`${cardState?
          '0px solid #777  ': '0px solid #ccc'}`}}>
          <div  className="popup-input-card">
       
       <label onMouseEnter={handleMouseEnter} 
    onMouseLeave={handleMouseLeave}   class="switchmute ">
<input  id="togglemute" onChange={e=>{setCardState(previousState => !previousState) 
  setTimeout(()=>{setMyCardState(!cardState) ;;handleCourseSettings(!cardState,)},1000) 
}} checked={cardState?"checked":""} type="checkbox"  
   /> 
 <span class="sliderlfmute round"></span>
</label>
   
   </div>
           </div>
          
         </div>


  </div>   </div>
    
)

}

export default SettingsToggleCard;






